import React from "react";
import { useState } from "react";
import AppBody from "../../components/AppBody";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { registerTrainer } from "../../../actions/admin/trainer/trainer_action";
import { ToastContainer, toast } from "react-toastify";

const AddTrainer = () => {
  const state = useSelector((state) => state.trainerReducer);
  const dispatch = useDispatch("");
  const navigate = useNavigate();
  const [trainer, setTrainer] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
  });

  const handleFormSubmit = () => {
    dispatch(registerTrainer(trainer));
  };

  if (state.is_done) {
    toast("Trainer register successfully!", {
      type: "success",
      position: "top-center",
     });
   }
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <ToastContainer />
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link to={"/trainer/list"} className="d-inline-block mt-2">
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Register Trainer
                </h4>
              </div>
              <div className="card-body  p-4 w-100 border-0 ">
                <form>
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainer.first_name}
                          onChange={(e) =>
                            setTrainer({
                              ...trainer,
                              first_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.first_name
                            ? state.errors.first_name
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainer.last_name}
                          onChange={(e) =>
                            setTrainer({
                              ...trainer,
                              last_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.last_name ? state.errors.last_name : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainer.mobile_no}
                          onChange={(e) =>
                            setTrainer({
                              ...trainer,
                              mobile_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.mobile_no ? state.errors.mobile_no : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainer.email}
                          onChange={(e) =>
                            setTrainer({ ...trainer, email: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.email ? state.errors.email : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <input
                        onClick={() => handleFormSubmit()}
                        type="button"
                        name="submit"
                        value="Submit"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AddTrainer;
